import { render, staticRenderFns } from "./Editorial.vue?vue&type=template&id=0d2466c8&"
import script from "./Editorial.vue?vue&type=script&lang=js&"
export * from "./Editorial.vue?vue&type=script&lang=js&"
import style0 from "./Editorial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports